import { render } from "./ProductRail.vue?vue&type=template&id=3173c386&scoped=true"
import script from "./ProductRail.vue?vue&type=script&lang=js"
export * from "./ProductRail.vue?vue&type=script&lang=js"

import "./ProductRail.vue?vue&type=style&index=0&id=3173c386&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3173c386"]])

export default __exports__